export default {

  usernameIsEmail: true,

  usernamePlaceholder: "name@company.co.uk"

}
